import { message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import axiosInstance from "../../../variables/api/axiosInstance";
import TextArea from "antd/es/input/TextArea";
const AnnulerCheque = (prop) => {
    const [modalDecaissementSinistre, setModalDecaissementSinistre] = useState(
        false
    );
    const [loading, setLoading] = useState(false);
    const [motif, setMotif] = useState('');


    const handleAnnulerChequeSubmit = async () => {
        setLoading(true);
        const decaissement = prop?.decaissement;
        if (!decaissement) {
            message.error("Erreur lors de l'annulation du chèque");
            setLoading(false);
            return;
        }

        if (!motif || motif.trim() === "") {
            message.error("Motif d'annulation obligatoire");
            setLoading(false);
            return;
        }

        const dto = {
            codeId: decaissement.codeId,
            numeroCheque: decaissement.numeroCheque,
            banque: decaissement.banque,
            motifAnnulerCheque: motif.trim()
            // ajouter d'autres champs DecaissementDTO si requis par le backend
        };

        try {
            await axiosInstance.put(
                `/api/decaissement/annuler-cheque`,
                JSON.stringify(dto),
                { headers: { 'Content-Type': 'application/json' } }
            );
            message.success("Annulation de chèque effectuée avec succès");
            if (prop.onSuccess) prop.onSuccess();
            else window.location.reload();
        } catch (err) {
            console.log(err);
            const msg = err?.response?.data?.message || "Erreur lors de l'annulation du chèque";
            message.error(msg);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        console.log(prop.decaissement);
        setModalDecaissementSinistre(prop.open);
    }, [prop.open]);

    return (
        <Modal
            title="Effectuer l'annulation de chèque"
            confirmLoading={loading}
            centered
            open={modalDecaissementSinistre}
            onOk={() => handleAnnulerChequeSubmit()}
            onCancel={prop.onCancel}
            okText={"Effectuer"}
            cancelText={"Annuler"}
            width={900}
        >
            <div className="row">
                <div className="col-12">
                    <label className="control-label">Motif de l'annulation</label>
                    <TextArea
                        id="motif"
                        formControlProps={{
                            fullWidth: true,
                        }}
                        name="motif"
                        value={motif}
                        onChange={(event) => {
                            setMotif(event.target.value);
                        }}
                    />
                </div>
                <br />
            </div>
        </Modal>
    );
};

AnnulerCheque.propTypes = {
    open: PropTypes.bool,
    // setOpen: PropTypes.func,
    decaissement: PropTypes.object,
    sinistre: PropTypes.object,
};

export default AnnulerCheque;
